module.exports = __webpack_public_path__ + "static/media/soups.cc8202e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/soups.svg
// module id = 73
// module chunks = 0